import React from "react"

import { ReactComponent as UserIcon } from "@common_assets/svg/user.svg"
import { Box, Button } from "@mui/material"
import SsoButtonContent from "components/common/ssoButtonContent"
import {
  ssoButtonBaseSx,
  ssoButtonVisualLayerSx,
} from "components/common/ssoButtonContent/ssoButton.styles"

interface IProps {
  text?: string
  onClick?: () => void
  fullWidth?: boolean
  disabled?: boolean
}

const CleverButton = ({
  text = "Sign in with Clever",
  onClick,
  fullWidth = true,
  disabled = false,
}: IProps) => {
  return (
    <Button
      onClick={onClick}
      fullWidth={fullWidth}
      disabled={disabled}
      sx={(theme) => ({
        ...ssoButtonBaseSx,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.mockup.neutral100,
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
        },
        "&:disabled": {
          backgroundColor: theme.palette.mockup.neutral90,
          color: theme.palette.mockup.neutral60,
        },
      })}
    >
      <Box sx={ssoButtonVisualLayerSx}>
        <SsoButtonContent
          icon={<UserIcon aria-hidden="true" style={{ width: "20px", height: "20px" }} />}
          iconSx={(theme) => ({ color: theme.palette.secondary.main })}
          text={text}
        />
      </Box>
    </Button>
  )
}

export default CleverButton
